/**
 * The sign-in page's error line, from the error Supabase Auth returns.
 *
 * Supabase answers an unknown email and a wrong password with the same
 * "Invalid login credentials" on purpose, so that the sign-in form cannot be
 * used to find out which addresses have an account. That one stays one
 * message here too. The others are told apart by the error's code when the
 * client provides one, and by its text otherwise.
 */
const BY_CODE = {
  invalid_credentials: "login.invalidCredentials",
  email_not_confirmed: "login.emailNotConfirmed",
  over_request_rate_limit: "login.rateLimited",
  over_email_send_rate_limit: "login.rateLimited",
  user_banned: "login.banned",
  validation_failed: "login.invalidEmail",
};

const BY_TEXT = [
  [/invalid login credentials|invalid_credentials/i, "login.invalidCredentials"],
  [/email not confirmed/i, "login.emailNotConfirmed"],
  [/rate limit|too many requests/i, "login.rateLimited"],
  [/banned/i, "login.banned"],
  [/invalid format|validate email|invalid email/i, "login.invalidEmail"],
  [/failed to fetch|network|load failed|fetch/i, "login.network"],
];

export function loginErrorKey(error) {
  const code = String(error?.code || "").toLowerCase();
  if (BY_CODE[code]) return BY_CODE[code];
  if (error?.name === "AuthRetryableFetchError") return "login.network";
  const text = String(error?.message || "");
  const hit = BY_TEXT.find(([pattern]) => pattern.test(text));
  return hit ? hit[1] : "login.failed";
}

export function loginErrorMessage(error, t) {
  return t(loginErrorKey(error));
}
